import { useMemo } from 'react'
import * as THREE from 'three'

interface PropsCobertor {
  visivel?: boolean
  posicao?: [number, number, number]
  escala?: number
}

/**
 * Cobertor Maleável Semi-Transparente para Proteção de Detritos de Vidro.
 *
 * Utilizado para cobrir o corpo e a cabeça da vítima durante o corte
 * do para-brisa (laminado) ou quebra dos vidros temperados.
 *
 * Permite ao socorrista interior e exterior continuar monitorando a face,
 * o nível de consciência e os movimentos respiratórios da vítima por
 * transparência, enquanto cria uma barreira impermeável contra cacos e pó de sílica.
 */
export function CobertorMaleavel3D({
  visivel = true,
  posicao = [0, 0, 0],
  escala = 1,
}: PropsCobertor) {
  // Gera uma malha suave e drapeada que contorna o corpo da vítima sentada
  const geometriaDrapeada = useMemo(() => {
    const geom = new THREE.PlaneGeometry(0.85, 1.25, 16, 20)
    const pos = geom.attributes.position!

    for (let i = 0; i < pos.count; i++) {
      const x = pos.getX(i)
      const y = pos.getY(i)

      // Modela curvatura suave em concha cobrindo cabeça, ombros e colo
      const curvaturaX = -Math.cos((x / 0.425) * (Math.PI / 2)) * 0.18
      const inclinacaoColo = y < 0 ? Math.sin((-y / 0.625) * Math.PI) * 0.12 : 0
      const rugosidadeTecido = Math.sin(x * 12) * Math.cos(y * 10) * 0.015

      pos.setZ(i, curvaturaX + inclinacaoColo + rugosidadeTecido)
    }

    geom.computeVertexNormals()
    return geom
  }, [])

  if (!visivel) return null

  return (
    <group position={posicao} scale={escala}>
      {/* Manta maleável semi-transparente */}
      <mesh
        geometry={geometriaDrapeada}
        position={[0, 0.45, 0.14]}
        rotation={[-Math.PI / 10, 0, 0]}
      >
        <meshPhysicalMaterial
          color="#9ec9eb"
          transparent
          opacity={0.52}
          roughness={0.25}
          metalness={0.05}
          transmission={0.3}
          thickness={0.02}
          side={THREE.DoubleSide}
          depthWrite={false}
        />
      </mesh>

      {/* Orla reforçada da manta (costura de contorno amarela de alta visibilidade) */}
      <mesh position={[0, 0.45, 0.14]} rotation={[-Math.PI / 10, 0, 0]}>
        <ringGeometry args={[0.42, 0.435, 32]} />
        <meshBasicMaterial color="#fcd34d" transparent opacity={0.65} side={THREE.DoubleSide} />
      </mesh>
    </group>
  )
}

